/**
 * Converts Contentful's "SubPage" content type to the appropriate component
 *
 * Copyright (c) 2020 Coursera
 * Author: Kelvin Nguyen
 */
import React from 'react'
import PropTypes from 'prop-types'
import cx from 'classnames'
import Container from '@material-ui/core/Container'
import Grid from '@material-ui/core/Grid'
import SectionWrapper from 'components/SectionWrapper'
import Typography from 'components/theme/Typography'
import { convertRichTextToComponent } from '../utils'
import styles from './ContentfulSubPage.module.scss'

const ContentfulSubPage = ({
  className,
  title,
  backgroundColor,
  content,
}) => (
  <div className={cx(className)}>
    <SectionWrapper
      className="py-2xl"
      backgroundColor={backgroundColor}>
      <Grid
        direction="column"
        justify="center"
        alignItems="center"
        spacing={4}
        container>
        <Grid item xs={10}>
          <Typography variant="d2">
            {title}
          </Typography>
        </Grid>
      </Grid>
    </SectionWrapper>
    <Container className={cx(styles.subPageContainer)}>
      <Grid
        direction="column"
        justify="center"
        alignItems="center"
        spacing={4}
        container>
        <Grid
          className="py-2xl px-md"
          xs={12}
          md={8}
          item>
          {convertRichTextToComponent(content, true)}
        </Grid>
      </Grid>
    </Container>
  </div>
)

ContentfulSubPage.propTypes = {
  className: PropTypes.string,
  title: PropTypes.string,
  backgroundColor: PropTypes.string,
  content: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
}

export default ContentfulSubPage
